import { render, staticRenderFns } from "./edit_reg_number_modal.vue?vue&type=template&id=8e96216c"
import script from "./edit_reg_number_modal.vue?vue&type=script&lang=js"
export * from "./edit_reg_number_modal.vue?vue&type=script&lang=js"
import style0 from "./edit_reg_number_modal.vue?vue&type=style&index=0&id=8e96216c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports